// @ts-nocheck
import Axios from "axios";

export default {
    //get请求
    async apiUtilGet(url,obj) :any{
        return(await Axios.get(url,{params:{...obj}}));
    },
    //get请求
    async apiUtilGetUrl(url) :any{
        return(await Axios.get(url));
    },

    //post请求
    async apiUtilPost(url,obj) :any{
        return (await Axios.post(url,{...obj}));
    },
    //post请求
    async apiUtilPostNoParam(url) :any{
        return (await Axios.post(url));
    },
    //postForm请求
    async apiUtilPostForm(url,FormData) :any{
        return (await Axios.post(url,FormData));
    },
    async apiUtilPostArray(url,obj){
        return (await Axios.post(url,obj)).data;
    },
    //get请求
    async apiUtilPutUrl(url) :any{
        return(await Axios.put(url));
    },

}
